import PropTypes from 'prop-types';
import { useState } from 'react';
import ReactModal from 'react-modal';

import CUSTOM_STYLES from '../utils/modalStyle';

import { PrimaryButton } from './Buttons/Buttons';
import styles from './GenericModalV2.module.scss';

function InfoModal({
  children,
  isOpen = true,
  mainText = '',
  modalLabel,
  onClickContinue,
  continueBtnText = 'Συνέχεια',
  modalClose,
}) {
  const [_isModalOpen, setIsModalOpen] = useState(isOpen);
  const _onClickContinue = onClickContinue || closeModal;
  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <ReactModal
      isOpen={_isModalOpen}
      onRequestClose={modalClose}
      style={CUSTOM_STYLES}
      contentLabel={modalLabel}
      ariaHideApp={false}
      className={styles.modalContent}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalContent}>
          <main>{children || <p className={styles.text}>{mainText}</p>}</main>
          <footer>
            <PrimaryButton onClick={_onClickContinue} data-cy="modal-accept-btn">
              {continueBtnText}
            </PrimaryButton>
          </footer>
        </div>
      </div>
    </ReactModal>
  );
}

InfoModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  mainText: PropTypes.string,
  modalLabel: PropTypes.string.isRequired,
  onClickContinue: PropTypes.func,
  continueBtnText: PropTypes.string,
};

export default InfoModal;
